export default __webpack_public_path__ + "static/media/burger-full.63284c36.jpg";